import React, { useContext } from "react";
import { Typography } from "@mui/material";
import { useTheme as useThemeV4 } from "@material-ui/core/styles";

/**
 * PageTitle Component
 * 
 * Standardized page title component that matches the Dashboard pattern.
 * Uses Material-UI v5 Typography with consistent styling across all pages.
 * 
 * Props:
 *   - children: The title text or content
 *   - sx: Optional style overrides (will be merged with default styles)
 * 
 * Features:
 *   - Consistent h4 variant
 *   - Bold font weight
 *   - 4-unit bottom margin
 *   - Primary color from whitelabel theme
 *   - Responsive and accessible
 */
const PageTitle = ({ children, sx = {} }) => {
  const themeV4 = useThemeV4(); // whitelabel theme (same as Dashboard)
  const PRIMARY_MAIN = themeV4?.palette?.primary?.main || "#88d03e";

  return (
    <Typography
      variant="h4"
      component="h1"
      fontWeight="bold"
      sx={{ 
        mb: 4, 
        color: PRIMARY_MAIN,
        ...sx 
      }}
    >
      {children}
    </Typography>
  );
};

export default PageTitle;
